// libraries.
import { useGoogleLogin, TokenResponse } from '@react-oauth/google';
import { useEffect } from 'react';
import { ButtonGoogleHabi } from './styles';
import { useDispatch } from 'react-redux';

// slices.
import { setUser } from '@domains/user';
import { CountryCode, getCountryCodeByEmail } from '@domains/country';
import { useLazyGetUserRoleQuery } from '@domains/user/store/api-slices/user-auth.endpoint';
import {
  setCountriesOptions,
  setCountry,
  setRolesFromCognito,
} from '@domains/user/store/slices/user-slice/user-slice';

interface PropsButtonGoogle {
  onSuccess?: (roles?: string[]) => void;
  onFailure?: () => void;
}

export const ButtonGoogle = ({ onSuccess, onFailure }: PropsButtonGoogle) => {
  const dispatch = useDispatch();
  const [triggerAuth, { data, isSuccess, isLoading }] =
    useLazyGetUserRoleQuery();

  const loginGoogle = useGoogleLogin({
    onSuccess: async (tokenResponse: TokenResponse) => {
      try {
        const res = await fetch(
          'https://www.googleapis.com/oauth2/v3/userinfo',
          {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
            },
          }
        );
        const profile = await res.json();
        dispatch(
          setUser({
            email: profile.email,
            familyName: profile.family_name,
            givenName: profile.given_name,
            googleId: profile.sub,
            imageUrl: profile.picture,
            name: profile.name,
          })
        );
        const country = getCountryCodeByEmail(profile.email);
        if (!country) return;
        triggerAuth({ country, userId: profile.sub, external: false });
      } catch (e) {
        onFailure && onFailure();
      }
    },
    onError: () => {
      onFailure && onFailure();
    },
  });

  useEffect(() => {
    if (isSuccess) {
      dispatch(setRolesFromCognito(data?.roles || []));
      dispatch(setCountriesOptions(data?.countriesSelect || []));
      dispatch(setCountry(data?.countriesByUser[0] || ('' as CountryCode)));
      onSuccess && onSuccess(data?.roles);
    }
  }, [isSuccess, data, dispatch]);

  if (isLoading) {
    return (
      <ButtonGoogleHabi>
        <p className="ingresar">Cargando...</p>
      </ButtonGoogleHabi>
    );
  }

  return (
    <ButtonGoogleHabi onClick={() => loginGoogle()}>
      <p className="ingresar">Ingresar</p>
    </ButtonGoogleHabi>
  );
};
